import { call, put, takeEvery } from "redux-saga/effects";

import {
    GET_PLATFORM_SETTINGS
} from "./actionTypes";

import {
    getPlatformSettingsSuccess,
    getPlatformSettingsError
} from "./actions";

import {
    genericGetRequest
} from "../../helpers/sf_backend_helper";

import { AppConfiguration } from "config";
import { bsh_getClientUserDetails } from "helpers/sf_browser_storage_helper";

function* onGetPlatformSettings() {
    try {
        let user = bsh_getClientUserDetails();
        const URL = `${AppConfiguration.BACKEND_URL}/api/v1/platform_settings`;
        const request_payload = {
            body: {},
            headers: {
                "Authorization": user.token,
                "accout_id": user.account_id,
                "Content-Type": "application/json"
            }
        }
        const response = yield call(genericGetRequest, URL, request_payload.body, request_payload.headers)
        yield put(getPlatformSettingsSuccess(response))
    } catch (error) {
        yield put(getPlatformSettingsError(error))
    }
}

function* GetPlatformSettingsSaga() {
    yield takeEvery(GET_PLATFORM_SETTINGS, onGetPlatformSettings)
}

export default GetPlatformSettingsSaga

